/**
 * Customary
 */

// Inputs
export const SELECT_UNIT = 'SELECT_UNIT';

// User inputs
export const SET_ALTITUDE_FEET = 'SET_ALTITUDE_FEET';
export const SET_OVEN_TEMP_F = 'SET_OVEN_TEMP_F';
export const SET_BAKING_MINS_CUST = 'SET_BAKING_MINS_CUST';
export const SET_BAKING_HOURS_CUST = 'SET_BAKING_HOURS_CUST';
export const SET_LIQUID_CUPS = 'SET_LIQUID_CUPS';
export const SET_LIQUID_PARTIAL_CUP = 'SET_LIQUID_PARTIAL_CUP';
export const SET_LIQUID_TBSP = 'SET_LIQUID_TBSP';
export const SET_LIQUID_TOTAL = 'SET_LIQUID_TOTAL';
export const SET_FLOUR_CUPS = 'SET_FLOUR_CUPS';
export const SET_FLOUR_PARTIAL_CUP = 'SET_FLOUR_PARTIAL_CUP ';
export const SET_FLOUR_TBSP = 'SET_FLOUR_TBSP';
export const SET_FLOUR_TOTAL = 'SET_FLOUR_TOTAL';
export const SET_SUGAR_CUPS = 'SET_SUGAR_CUPS';
export const SET_SUGAR_PARTIAL_CUP = 'SET_SUGAR_PARTIAL_CUP';
export const SET_SUGAR_TBSP = 'SET_SUGAR_TBSP';
export const SET_SUGAR_TOTAL = 'SET_SUGAR_TOTAL';
export const SET_BAKING_POWDER_TSP = 'SET_BAKING_POWDER_TSP';
export const SET_BAKING_POWDER_PARTIAL_TSP = 'SET_BAKING_POWDER_PARTIAL_TSP';
export const SET_BAKING_POWDER_TOTAL = 'SET_BAKING_POWDER_TOTAL';
export const SET_BAKING_SODA_TSP = 'SET_BAKING_SODA_TSP';
export const SET_BAKING_SODA_PARTIAL_TSP = 'SET_BAKING_SODA_PARTIAL_TSP';
export const SET_BAKING_SODA_TOTAL = 'SET_BAKING_SODA_TOTAL';
export const SET_YEAST_TSP = 'SET_YEAST_TSP';
export const SET_YEAST_PARTIAL_TSP = 'SET_YEAST_PARTIAL_TSP';
export const SET_YEAST_TOTAL = 'SET_YEAST_TOTAL';

// Cacluations
export const CALCULATE_MIN_OVEN_TEMP_CUST = 'CALCULATE_MIN_OVEN_TEMP_CUST';
export const CALCULATE_MAX_OVEN_TEMP_CUST = 'CALCULATE_MAX_OVEN_TEMP_CUST';
export const CALCULATE_MIN_TIME_CUST = 'CALCULATE_MIN_TIME_CUST';
export const CALCULATE_MAX_TIME_CUST = 'CALCULATE_MAX_TIME_CUST';
export const CALCULATE_BAKING_POWDER_CUST = 'CALCULATE_BAKING_POWDER_CUST';
export const CALCULATE_BAKING_SODA_CUST = 'CALCULATE_BAKING_SODA_CUST';
export const CALCULATE_YEAST_CUST = 'CALCULATE_YEAST_CUST';
export const CALCULATE_FLOUR_CUST = 'CALCULATE_FLOUR_CUST';
export const CALCULATE_MIN_LIQUID_CUST = 'CALCULATE_MIN_LIQUID_CUST';
export const CALCULATE_MAX_LIQUID_CUST = 'CALCULATE_MAX_LIQUID_CUST';
export const CALCULATE_SUGAR_CUST = 'CALCULATE_SUGAR_CUST';

// Displaying calculations for user
export const SET_DISPLAY_TEMP_CUST = 'SET_DISPLAY_TEMP_CUST';
export const SET_DISPLAY_TIME_CUST = 'SET_DISPLAY_TIME_CUST';
export const SET_DISPLAY_FLOUR_CUST = 'SET_DISPLAY_FLOUR_CUST';
export const SET_DISPLAY_LIQUID_CUST = 'SET_DISPLAY_LIQUID_CUST';
export const SET_DISPLAY_SUGAR_CUST = 'SET_DISPLAY_SUGAR_CUST';
export const SET_DISPLAY_YEAST_CUST = 'SET_DISPLAY_YEAST_CUST';
export const SET_DISPLAY_BAKING_POWDER_CUST = 'SET_DISPLAY_BAKING_POWDER_CUST';
export const SET_DISPLAY_BAKING_SODA_CUST = 'SET_DISPLAY_BAKING_SODA_CUST';

// Form actions
export const CLEAR_FORM = 'CLEAR_FORM';
